import {IBillingDoc} from "../interface.billing";
import {getPDV, getWorkBook, saveXLSFile} from "../../commonMethods";
import moment from "moment";
import {getNumberToString} from "../../../../../utils/methods";

export const getSocarXLSXFile = async ({
    numBill,
    supplier,
    holder,
    tax,
    shortTypeGoods,
    typeGoods,
    sum
}: IBillingDoc) => {

    const {convertedInteger, integerCurrency, fractionalString, fractionalCurrency} = getNumberToString(sum);
    const sumToString = `${convertedInteger} ${integerCurrency} ${fractionalString} ${fractionalCurrency}`;
    /**
     * ПДВ и Сумма без ПДВ
     */
    const {pdv, bezPdv} = getPDV(sum, tax);
    /**
     * ПДВ
     */
    const PDV = pdv;

    const wb = await getWorkBook();
    const ws = wb.worksheets[0];
    /**
     * Одержувач телефон
     */
    ws.getCell(12, 3).value = holder.fullName;
    ws.getCell(13, 3).value = `тел. ${holder.phone}`;
    /**
     * Угода
     */
    ws.getCell(15, 3).value = holder.contractNumber;
    /**
     * Призначення платежу
     */
    ws.getCell(16, 3).value = `сплата за ${shortTypeGoods} зг. рах.№ ${numBill} від ${moment().format('DD.MM.YY')} &${holder.okpo}& , ПДВ ${tax}%`;
    /**
     * Номер рахунку
     */
    ws.getCell(18, 3).value = `Рахунок № ${numBill}`;
    /**
     * Від якого числа
     */
    ws.getCell(19, 7).value = `від ${moment().format('DD.MM.YY')} р.`;
    /**
     * Найменування за що
     */
    ws.getCell(22, 2).value = typeGoods;
    /**
     * Кол-во
     */
    ws.getCell(22, 7).value = sum;
    /**
     * Сума
     */
    ws.getCell(22, 10).value = sum;
    /**
     * Процентная ставка
     */
    ws.getCell(22, 11).value = `${tax}%`;
    /**
     * Разом без ПДВ
     */
    ws.getCell(23, 10).value = bezPdv;
    /**
     * ПДВ
     */
    ws.getCell(24, 10).value = PDV;
    /**
     * Разом без ПДВ
     */
    ws.getCell(25, 10).value = sum;
    /**
     * Сума прописом
     */
    ws.getCell(28, 1).value = sumToString;

    await saveXLSFile(wb, numBill);
};
